module.exports = __webpack_public_path__ + "img/spider_attacking_car.fa4ed774.jpg";